import { config } from 'affiny-core/env';
import { IRootState } from 'affiny-core/modules/state';

export const getBaseApiHostname = (state: IRootState) =>
  state.configurations.baseApiHostname || config.env.meeticApi.baseApiHostname;

export const getLoginCaptcha = (state: IRootState) =>
  state.configurations.captcha && state.configurations.captcha.login;

export const getRegistrationCaptcha = (state: IRootState) =>
  state.configurations.captcha && state.configurations.captcha.registration;

/* ***** *****  feature flipping (ABTest configurations) ***** ***** */
export const selectFeatureFlippingAttribute = (
  state: IRootState,
  flippingKey: string
) => state.configurations?.featureFlipping?.[flippingKey];

/* ***** *****  Iovation blackbox  ***** ***** */
export const selectIovationBlackbox = (state: IRootState) =>
  state.configurations.blackbox;
